<app-shared-dialog
  [title]="'user.user_details' | translate"
  [options]="dialogOptions"
  (cancel)="close()">
  <div class="user-detail-dialog__body">
    <div class="user-detail-dialog__identity">
      <div
        class="user-detail-dialog__avatar"
        [style.background-color]="!user.image ? getUserColor(user) : 'transparent'">
        <img
          *ngIf="user.image"
          [src]="getImageSrc(user.image)"
          [alt]="user.name"
          class="user-detail-dialog__avatar-img" />
        <span
          *ngIf="!user.image"
          class="user-detail-dialog__avatar-initials">{{ getUserInitials(user) }}</span>
      </div>
      <div>
        <p class="user-detail-dialog__name">{{ user.name }}</p>
        <p class="user-detail-dialog__email">{{ user.email }}</p>
      </div>
    </div>

    <div class="user-detail-dialog__status">
      <span
        class="user-detail-dialog__status-badge"
        [class.user-detail-dialog__status-badge--active]="user.enabled"
        [class.user-detail-dialog__status-badge--inactive]="!user.enabled">
        {{ getUserStatusLabel(user.enabled) }}
      </span>
      <span class="user-detail-dialog__last-active" *ngIf="user.last_activity">
        {{ 'common.last_activity' | translate }}: {{ getLastActivity() }}
      </span>
    </div>

    <ng-container *ngIf="userRole as role; else noRole">
      <div class="user-detail-dialog__section">
        <p class="user-detail-dialog__section-label">{{ 'user.roles' | translate }}</p>
        <div class="user-detail-dialog__role-card">
          <div class="user-detail-dialog__role-header">
            <span class="user-detail-dialog__role-dot" [style.background-color]="getRoleColor(role)"></span>
            <span class="user-detail-dialog__role-name">{{ getRoleLabel(role.name) }}</span>
            <span class="user-detail-dialog__role-protected-badge" *ngIf="role.is_protected">System</span>
          </div>
          <p class="user-detail-dialog__role-description" *ngIf="role.description">{{ role.description }}</p>
          <div class="user-detail-dialog__role-chips">
            <span class="user-detail-dialog__chip">{{ user.modules?.length || 0 }} {{ 'user.features' | translate | lowercase }}</span>
          </div>
        </div>
      </div>

      <ng-container *ngIf="getPermissionSummaryModules() as modules">
        <div class="user-detail-dialog__section" *ngIf="modules.length">
          <p class="user-detail-dialog__section-label">{{ 'user.permissions_summary' | translate }}</p>
          <div class="user-detail-dialog__permissions-summary">
            <div class="user-detail-dialog__permission-row" *ngFor="let entry of modules">
              <p class="user-detail-dialog__permission-feature">{{ getModuleLabel(entry.module) }}</p>
              <span class="user-detail-dialog__permission-badge" [class.user-detail-dialog__permission-badge--own]="entry.own_data">
                {{ (entry.own_data ? 'common.own' : 'common.all') | translate | lowercase }}
              </span>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <ng-template #noRole>
      <div class="user-detail-dialog__section">
        <p class="user-detail-dialog__section-label">{{ 'user.roles' | translate }}</p>
        <p class="user-detail-dialog__empty">{{ 'settings.no_role_assigned' | translate }}</p>
      </div>
    </ng-template>
  </div>

  <div customConfirm class="user-detail-dialog__footer" *ngIf="!user.is_super_admin">
    <ui-button
      [type]="user.enabled ? 'danger' : 'secondary'"
      [icon]="user.enabled ? 'user-inactive' : 'user-active'"
      [label]="getUserToggleActionLabel(user.enabled) | uppercase"
      (click)="onToggleEnabled()">
    </ui-button>

    <ui-button
      type="primary"
      icon="pen-cc"
      [label]="('common.edit' | translate) | uppercase"
      (click)="onEditUser()">
    </ui-button>
  </div>
</app-shared-dialog>
